export const countAsync = async (source, predicate) => {
    let count = 0;
    for (const value of source) {
        if (await predicate(value) === true) {
            count++;
        }
    }
    return count;
};
